/**
 * Auth0 Configuration for PIGNA Studio
 * 
 * IMPORTANTE: Usa STESSO tenant e app di oystar.ai
 * ma con redirect URL diverso per studio.oystar.ai
 */

// Lista email admin (possono vedere tutti i flow)
export const ADMIN_EMAILS = [
  'framar333@hotmail.com',
];

// DEBUG: Verifica env vars
console.log('🔐 Auth0 Config:');
console.log('  DOMAIN:', import.meta.env.VITE_AUTH0_DOMAIN || '❌ NON DEFINITO');
console.log('  CLIENT_ID:', import.meta.env.VITE_AUTH0_CLIENT_ID ? '✅ Definito' : '❌ NON DEFINITO');
console.log('  AUDIENCE:', import.meta.env.VITE_AUTH0_AUDIENCE || '❌ NON DEFINITO');

export const auth0Config = {
  // Domain Auth0 (stesso di oystar.ai)
  domain: import.meta.env.VITE_AUTH0_DOMAIN || 'dev-31v3wlvf1rwj7gjc.eu.auth0.com',
  
  // Client ID (stesso di oystar.ai o separato se preferisci)
  clientId: import.meta.env.VITE_AUTH0_CLIENT_ID || 'Wf2NZanza0GFsGvtwpuoAjckqcoUdxU5',
  
  // Redirect URI (SPECIFICO per studio!)
  // In dev usa localhost, in prod usa window.location.origin
  redirectUri: import.meta.env.DEV
    ? 'http://localhost:5173/callback'
    : (typeof window !== 'undefined' 
        ? window.location.origin + '/callback'
        : 'https://studio.oystar.ai/callback'),
  
  // Audience (API identifier)
  audience: import.meta.env.VITE_AUTH0_AUDIENCE || 'https://llm.marinuzzi.it',
  
  // Scope richiesti
  scope: 'openid profile email',
  
  // Cache location
  cacheLocation: 'localstorage' as const,
  
  // Use refresh tokens
  useRefreshTokens: true,
};

/**
 * Verifica se un utente ha accesso a Studio
 * 
 * Criteri:
 * - Deve essere autenticato
 * - Deve avere ruolo 'enterprise' O 'admin'
 */
export const hasStudioAccess = (user: any): boolean => {
  if (!user) {
    console.warn('🔐 hasStudioAccess: user è null/undefined');
    return false;
  }
  
  // Namespace custom claims Auth0
  const namespace = 'https://oystar.ai/';
  const namespacedRole = user[`${namespace}role`];
  const directRole = user.role;
  const role = namespacedRole || directRole || 'free';
  
  // DEBUG: Log completo per capire il problema
  console.log('🔐 hasStudioAccess DEBUG:');
  console.log('  User object keys:', Object.keys(user));
  console.log(`  ${namespace}role:`, namespacedRole);
  console.log('  user.role:', directRole);
  console.log('  Final role:', role);
  console.log('  Has access:', ['enterprise', 'admin'].includes(role));
  
  // Permetti accesso a enterprise e admin
  return ['enterprise', 'admin'].includes(role);
};

/**
 * Estrae il ruolo dell'utente dal token
 */
export const getUserRole = (user: any): string => {
  if (!user) return 'guest';
  
  const namespace = 'https://oystar.ai/';
  return user[`${namespace}role`] || user.role || 'free';
};

/**
 * Verifica se l'utente è admin (per email)
 */
export const isAdminUser = (user: any): boolean => {
  if (!user?.email) return false;
  return ADMIN_EMAILS.includes(user.email);
};

